import "./OutdoorLivingDecks.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Outdoor from "./sections/Outdoor";
import DeckRemodeling from "./sections/DeckRemodeling";
import OutdoorFaq from "./sections/OutdoorFaq";
import Outdoors from "./sections/Outdoors";
import Footer from "@/reusable_sections/Footer";
export default function OutdoorLivingDecksPage() {
  return <div>
      <Header />
      <Hero />
      <Outdoor />
      <DeckRemodeling />
      <OutdoorFaq />
      <Outdoors />
      <Footer />
    </div>;
}